import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { categoriesArrayPropTypes, userPropTypes } from 'helpers/propTypes';
import { logout } from 'redux/actions/user.actions';
import { openLoginModal, openRegisterModal, openSearchModal } from 'redux/actions/modal.actions';
import { cartSizeSelector } from 'redux/selectors/cart.selector';
import { getSearch } from 'redux/actions/product.actions';
import history from 'helpers/history';
import Menu from 'components/main/Header/Menu';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import Button from 'components/commons/Button';

import Swal from 'sweetalert2';
import Navbar from 'components/main/Header/Navbar';
import TopNav from 'components/main/Header/TopNav';
import NavbarTextil from 'components/main/Header/Navbar/NavbarTextil';
import TopNavTextil from 'components/main/Header/TopNav/TopNavTextil';
import NavbarNeo from 'components/main/Header/Navbar/NavbarNeo';
import TopNavNeo from 'components/main/Header/TopNav/TopNavNeo';
import NavBarD5 from 'components/main/Header/Navbar/NavBarD5';
import NavBarD7 from 'components/main/Header/Navbar/NavBarD7';
import NavbarMan from 'components/main/Header/Navbar/NavBarMan/NavbarMan';
import TopNavD7 from 'components/main/Header/TopNav/TopNavD7';
import TopNavD1 from 'components/main/Header/TopNav/TopNavD1';
import NavBarD8 from 'components/main/Header/Navbar/NavBarD8';
import TopNavD8 from 'components/main/Header/TopNav/TopNavD8';
import { getStoreDesign } from 'constants/storeDesigns';
import { isCustomDesign } from 'constants/customDesign';

const HeaderContainer = (props) => {
  const {
    categories, cartSize, logoutAction, openLoginModalAction,
    openRegisterModalAction, openSearchModalAction, user, onlyUsers,
    client, subCategories, getSearchAction, products, contact, envios,
    cuotasMP, showMPButton, minimumPurchase, catalogs, frequentQuestions,
  } = props;
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchProduct, setSearchProduct] = useState('');
  const hasFrequentQuestions = Array.isArray(frequentQuestions) && frequentQuestions.length > 0;


  useEffect(() => {
    setIsSearchActive(false);
    setSelectedProduct(null);
    setSearchProduct('');
    getSearchAction('');
  }, [getSearchAction]);

  const design = client?.design;
  useEffect(() => {
    const cls = 'design-7';
    if (design === 7) document.body.classList.add(cls);
    else document.body.classList.remove(cls);
    return () => document.body.classList.remove(cls);
  }, [design]);

  const removeAccents = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const dots = (word) => (word.length > 45 ? `${word.substring(0, 45)}...` : word);

  const handleInputChange = (_, value) => {
    setSearchProduct(value);
    if (value !== undefined) getSearchAction(removeAccents(value));
  };

  const onSubmit = () => {
    const search = removeAccents(searchProduct).trim().toLowerCase();
    history.push(`/busqueda/${encodeURIComponent(search)}`);
  };

  const productSelected = (_, product) => {
    if (product.id) {
      history.push(`/producto/${encodeURIComponent(product.code)}`);
      setSelectedProduct(product);
    } else {
      const search = removeAccents(product).trim().toLowerCase();
      history.push(`/busqueda/${encodeURIComponent(search)}`);
    }
  };

  const logoutModal = () => {
    Swal.fire({
      title: '¿Estás seguro de que deseas cerrar sesión?',
      // text: "¡Perderás todo lo seleccionado!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        logoutAction();
      }
    });
  };

  const renderItem = (item) => (
    <div
      className="search-item"
      data-testid={`search-item-${item.id}`}
      key={item.id}
      role="presentation"
    >
      <div className="row">
        <div className="col-md-4 search-item-image">
          <img src={item.image1} alt={item.name} />
        </div>
        <div className="col-md-8 search-item-info">
          <ul>
            <li className="d-flex flex-row text-auto">
              <span className="search-item-title">
                {dots(item.name)}
              </span>
            </li>
            <li className="text-auto">
              <span className="search-item-price">
                {`$${item.sale ? item.sale.toLocaleString('de-DE') : item.price.toLocaleString('de-DE')}`}
                {!!item.sale && <span>{`$${item.price.toLocaleString('de-DE')}`}</span>}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );

  const renderResponsiveMenu = () => (
    <>
      <div
        className={`fs-menu-overlay${isMenuActive ? ' pointer-active' : ''}`}
        role="presentation"
        onClick={() => setIsMenuActive(false)}
      />
      <div className={`hamburger-menu${isMenuActive ? ' active' : ''}`}>
        <div className="hamburger-menu-content">
          <Menu
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMobile
            isUserLoggedIn={!!user}
            ulClassName="menu-top-nav"
            logout={logoutModal}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            contact={contact}
            client={client}
            hasFrequentQuestions={hasFrequentQuestions}
          />
        </div>
      </div>
    </>
  );

  const renderResponsiveSearch = () => (
    <>
      <div
        className={`fs-search-menu-overlay${isSearchActive ? ' search-pointer-active' : ''}`}
        role="presentation"
        onClick={() => setIsSearchActive(false)}
      />
      <div className={`search-menu${isSearchActive ? ' active' : ''}`}>
        <div className="search-menu-content">
          <div className="nabvar-searchContainer-mobile">
            <div className="autocomplete">
              <Autocomplete
                key="auto-complete-search"
                disablePortal
                id="combo-box-demo"
                // classes="nabvar-search"
                options={products}
                freeSolo
                filterOptions={(options) => options}
                onChange={(event, product) => productSelected(event, product)}
                value={selectedProduct}
                onInputChange={handleInputChange}
                inputValue={searchProduct}
                getOptionSelected={(option, product) => option.id === product.id}
                getOptionLabel={(option) => (typeof option === 'string' ? option : renderItem(option))}
                renderInput={(params) => (<TextField {...params} placeholder="Buscar..." />)}
              />
              {searchProduct.trim().length >= 3 && (
                <Button
                  buttonClass="nabvar-btn-search"
                  disabled={false}
                  onClick={onSubmit}
                  text={<i className="fa fa-search icon-orange" aria-hidden="true" />}
                  type="button"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const storeDesign = getStoreDesign(client?.design);
  if (isCustomDesign(client)) {
    return (
      <header className="header header-store-design header-store-design--custom trans-300">
        <TopNavD1 client={client} envios={envios} minimumPurchase={minimumPurchase} />
        <NavBarD5
          cartSize={cartSize}
          categories={categories}
          closeMenu={() => setIsMenuActive(false)}
          isMenuActive={isMenuActive}
          isUserLoggedIn={!!user}
          openMenu={() => setIsMenuActive(true)}
          openSearchModal={openSearchModalAction}
          logout={logoutAction}
          openLoginModal={openLoginModalAction}
          openRegisterModal={openRegisterModalAction}
          user={user}
          show={onlyUsers === false || (onlyUsers === true && !!user)}
          client={client}
          subCategories={subCategories}
          openSearch={() => setIsSearchActive(true)}
          closeSearch={() => setIsSearchActive(false)}
          isSearchActive={isSearchActive}
          products={products}
          filterOptions={(options) => options}
          setSelectedProduct={productSelected}
          selectedProduct={selectedProduct}
          onSearchProductChange={handleInputChange}
          searchProduct={searchProduct}
          onSubmit={onSubmit}
          renderItem={renderItem}
        />
      </header>
    );
  }

  if (storeDesign) {
    return (
      <header className={`header header-store-design header-store-design--${storeDesign.slug} trans-300`}>
        <TopNavD1 client={client} envios={envios} minimumPurchase={minimumPurchase} />
        <NavBarD5
          cartSize={cartSize}
          categories={categories}
          closeMenu={() => setIsMenuActive(false)}
          isMenuActive={isMenuActive}
          isUserLoggedIn={!!user}
          openMenu={() => setIsMenuActive(true)}
          openSearchModal={openSearchModalAction}
          logout={logoutAction}
          openLoginModal={openLoginModalAction}
          openRegisterModal={openRegisterModalAction}
          user={user}
          show={onlyUsers == false || (onlyUsers == true && !!user)}
          client={client}
          subCategories={subCategories}
          openSearch={() => setIsSearchActive(true)}
          closeSearch={() => setIsSearchActive(false)}
          isSearchActive={isSearchActive}
          products={products}
          filterOptions={(options) => options}
          setSelectedProduct={productSelected}
          selectedProduct={selectedProduct}
          onSearchProductChange={handleInputChange}
          searchProduct={searchProduct}
          onSubmit={onSubmit}
          renderItem={renderItem}
        />
      </header>
    );
  }

  switch (client?.design) {
    case 3:
      return (
        <header className="header trans-300">
          <TopNavTextil
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            client={client}
          />
          <NavbarTextil
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            client={client}
            subCategories={subCategories}
            openSearch={() => setIsSearchActive(true)}
            closeSearch={() => setIsSearchActive(false)}
            isSearchActive={isSearchActive}
            products={products}
            filterOptions={(options) => options}
            setSelectedProduct={productSelected}
            selectedProduct={selectedProduct}
            onSearchProductChange={handleInputChange}
            searchProduct={searchProduct}
            onSubmit={onSubmit}
            renderItem={renderItem}
            hasFrequentQuestions={hasFrequentQuestions}
          />
        </header>
      )
    case 4:
      return (
        <header className="header header-neo trans-300">
          <TopNavNeo
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            client={client}
          />
          <NavbarNeo
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            client={client}
            subCategories={subCategories}
            products={products}
            setSelectedProduct={productSelected}
            selectedProduct={selectedProduct}
            onSearchProductChange={handleInputChange}
            searchProduct={searchProduct}
            onSubmit={onSubmit}
            hasFrequentQuestions={hasFrequentQuestions}
          />
        </header>
      );
    case 5:
      return (
        <header className="header header-neo trans-300">
          <NavBarD5
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            client={client}
            subCategories={subCategories}
            openSearch={() => setIsSearchActive(true)}
            closeSearch={() => setIsSearchActive(false)}
            isSearchActive={isSearchActive}
            products={products}
            filterOptions={(options) => options}
            setSelectedProduct={productSelected}
            selectedProduct={selectedProduct}
            onSearchProductChange={handleInputChange}
            searchProduct={searchProduct}
            onSubmit={onSubmit}
            renderItem={renderItem}
          />
        </header>
      );
    case 6:
      return (
        <header className="header header-neo trans-300">
          <TopNavNeo
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            client={client}
          />
          <NavbarMan
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            client={client}
            subCategories={subCategories}
            openSearch={() => setIsSearchActive(true)}
            closeSearch={() => setIsSearchActive(false)}
            isSearchActive={isSearchActive}
            products={products}
            filterOptions={(options) => options}
            setSelectedProduct={productSelected}
            selectedProduct={selectedProduct}
            onSearchProductChange={handleInputChange}
            searchProduct={searchProduct}
            onSubmit={onSubmit}
            renderItem={renderItem}
          />
        </header>
      );
    case 7:
      return (
        <header className="header header-neo trans-300">
          <TopNavD7 client={client} envios={envios} />
          <NavBarD7
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            client={client}
            subCategories={subCategories}
            openSearch={() => setIsSearchActive(true)}
            closeSearch={() => setIsSearchActive(false)}
            isSearchActive={isSearchActive}
            products={products}
            filterOptions={(options) => options}
            setSelectedProduct={productSelected}
            selectedProduct={selectedProduct}
            onSearchProductChange={handleInputChange}
            searchProduct={searchProduct}
            onSubmit={onSubmit}
            renderItem={renderItem}
            cuotasMP={cuotasMP}
            showMPButton={showMPButton}
          />
        </header>
      );
    case 8:
      return (
        <header className="header trans-300">
          <TopNavD8
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            client={client}
            envios={envios}
            minimumPurchase={minimumPurchase}
          />
          <NavBarD8
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            handleClick={() => {}}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            client={client}
            subCategories={subCategories}
            showCatalogo={catalogs.length > 0}
            hasFrequentQuestions={hasFrequentQuestions}
          />
        </header>
      );
    default:
      return (
        <header className="header trans-300">
          {client && (client.design === 1 || client.design === 8) ? (
            <TopNavD1 client={client} envios={envios} minimumPurchase={minimumPurchase} />
          ) : null}
          {client && (!client.design || client.design === 2) ? <TopNav
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            client={client}
          /> : <></>}
          <Navbar
            cartSize={cartSize}
            categories={categories}
            closeMenu={() => setIsMenuActive(false)}
            isMenuActive={isMenuActive}
            isUserLoggedIn={!!user}
            openMenu={() => setIsMenuActive(true)}
            openSearchModal={openSearchModalAction}
            logout={logoutAction}
            openLoginModal={openLoginModalAction}
            openRegisterModal={openRegisterModalAction}
            user={user}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            client={client}
            subCategories={subCategories}
            hasFrequentQuestions={hasFrequentQuestions}
          />
        </header>
      );
  }
};

const mapStateToProps = (state) => ({
  cartSize: cartSizeSelector(state),
  categories: state.category.items,
  user: state.user.data,
  onlyUsers: state.app.onlyUsers,
  client: state.app.client,
  subCategories: state.subCategory.items,
  products: state.product.search,
  contact: state.app.contact,
  envios: state.app.envios,
  cuotasMP: state.app.cuotasMP,
  showMPButton: state.app.showMPButton,
  minimumPurchase: state.app.minimumPurchase,
  catalogs: state.app.catalogs,
  frequentQuestions: state.app.frequentQuestions,
});

const mapDispatchToProps = (dispatch) => ({
  logoutAction: bindActionCreators(logout, dispatch),
  openLoginModalAction: bindActionCreators(openLoginModal, dispatch),
  openRegisterModalAction: bindActionCreators(openRegisterModal, dispatch),
  openSearchModalAction: bindActionCreators(openSearchModal, dispatch),
  getSearchAction: bindActionCreators(getSearch, dispatch),
});

HeaderContainer.defaultProps = {
  user: null,
  minimumPurchase: 0,
};

HeaderContainer.propTypes = {
  cartSize: PropTypes.number.isRequired,
  categories: categoriesArrayPropTypes.isRequired,
  logoutAction: PropTypes.func.isRequired,
  openLoginModalAction: PropTypes.func.isRequired,
  openRegisterModalAction: PropTypes.func.isRequired,
  openSearchModalAction: PropTypes.func.isRequired,
  user: userPropTypes,
  minimumPurchase: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);
